/**
 * StartFromScratchCard Component
 *
 * Vertical card that starts the user with a completely blank report
 * canvas — no template, no smart auto-generation. For agencies that
 * want to design every widget from scratch.
 */

import { FileDashedIcon } from "@phosphor-icons/react";

interface StartFromScratchCardProps {
  onStart: () => void;
  disabled?: boolean;
}

export function StartFromScratchCard({
  onStart,
  disabled = false,
}: StartFromScratchCardProps) {
  return (
    <button
      type="button"
      onClick={onStart}
      disabled={disabled}
      data-testid="start-from-scratch-card"
      className={`relative overflow-hidden rounded-[30px] bg-card px-6 py-6 h-full w-full text-left shadow-sm cursor-pointer border-[0.5px] border-[var(--hairline)] ${
        disabled ? "opacity-50 pointer-events-none" : ""
      }`}
    >
      <div className="flex flex-col items-center text-center gap-3 h-full">
        <FileDashedIcon size={24} className="text-foreground" />
        <div>
          <h3 className="text-base font-semibold text-foreground">
            Start from Scratch
          </h3>
          <p className="text-sm text-foreground/70 mt-1">
            Begin with a blank canvas and design every section of your report
            exactly the way you want it.
          </p>
        </div>
      </div>
    </button>
  );
}
